import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useCurrentUser } from "../../UserProvider";
import { api, setAuthToken } from "../../utils/api";
import usePageTitle from "../../hooks/PageTitle";

export default function ClaimPage() {
  usePageTitle("Claim Access");

  const navigate = useNavigate();
  const { access_token } = useParams();
  const { refreshUser } = useCurrentUser();

  useEffect(() => {
    const claim = async () => {
      if (!access_token) {
        navigate("/login", { replace: true });
        return;
      }

      try {
        const { data } = await api.post("/auth/claim", {
          access_token,
        });

        // store JWTs
        setAuthToken(data);

        // load user
        await refreshUser();

        // redirect
        navigate(`/job/${data.job_posting_id}`, { replace: true });

      } catch (err) {
        console.error(err);

        // fallback
        navigate("/login", { replace: true });
      }
    };

    claim();
  }, [access_token, navigate, refreshUser]);

  return (
    <div className="__claim-page">
      <h1 className="form__title">Claiming your access...</h1>
      <p className="form__subtitle">
        Please wait while we securely log you in.
      </p>
    </div>
  );
}